import { Dialog, Typography } from 'components'
import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteHoliday } from 'store/firebase';
import { useAlert, useReduxDispatch } from 'store/hooks';
import { fetchHolidays } from 'store/holiday';

const ConfirmDeleteDialog = ({ tobeDeletedItem, open, onClose, setAction }) => {
  const { alertWaiting, alertSuccess, alertError } = useAlert();
  const getHolidayList = useReduxDispatch(fetchHolidays);
  const handleDeleteHoliday = () => {
    alertWaiting();
    deleteHoliday(tobeDeletedItem)
      .then(() => {
        alertSuccess('Berhasil menghapus hari libur!');
        setAction();
        getHolidayList();
      })
      .catch((err) => alertError(err?.message || err));
  }
  return (
    <Dialog maxWidth='xs'
      title='Hapus Libur'
      open={open}
      action={{
        label: 'Ya, Hapus Libur',
        onClick: () => {
          handleDeleteHoliday();
          onClose(false);
        }
      }}
      onClose={() => onClose(false)}
    >{
        <div style={{
          padding: '10px 10px',
          textAlign: 'center'
        }}>
          <FontAwesomeIcon
            icon='exclamation-triangle'
            size='lg'
            color='#F7C04A'
            style={{
              marginBottom: 10
            }}
          />
          <Typography align='center'>
                  Apakah Anda Yakin Akan Menghapus Libur:
          </Typography>
          <Typography align='center' type='bold'>
            {tobeDeletedItem?.title} ({moment(tobeDeletedItem?.startDate).format('DD MMM')} s/d {moment(tobeDeletedItem?.endDate).format('DD MMM YYYY')})
          </Typography></div>
      }</Dialog>
  )
}

export default ConfirmDeleteDialog
